import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "table-transmission",
  style: {"margin-top":"3%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Novedad"),
  /*#__PURE__*/_createElementVNode("th", null, "Fecha inicio novedad"),
  /*#__PURE__*/_createElementVNode("th", null, "Sueldo"),
  /*#__PURE__*/_createElementVNode("th", null, "Sueldo trabajado"),
  /*#__PURE__*/_createElementVNode("th", null, "Salario integral"),
  /*#__PURE__*/_createElementVNode("th", null, "Tipo de trabajador")
], -1)
const _hoisted_3 = { class: "error-transmission" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_6 = { class: "tooltip-container" }
const _hoisted_7 = { class: "tooltip-container" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_10 = { class: "table-transmission" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Subtipo de trabajador"),
  /*#__PURE__*/_createElementVNode("th", null, "Alto riesgo pensión"),
  /*#__PURE__*/_createElementVNode("th", null, "Días laborados"),
  /*#__PURE__*/_createElementVNode("th", null, "Fecha ingreso"),
  /*#__PURE__*/_createElementVNode("th", null, "Fecha retiro")
], -1)
const _hoisted_12 = { class: "error-transmission" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_15 = { class: "tooltip-container" }
const _hoisted_16 = { class: "tooltip-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createVNode(_component_Dropdown, {
              showClear: "",
              modelValue: $setup.hasNovelty,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.hasNovelty) = $event)),
              disabled: true,
              options: $setup.Decision(),
              optionLabel: "nombre",
              optionValue: "nombre",
              placeholder: "Seleccione",
              class: "pv-input-size",
              onChange: $setup.Novedad
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_Calendar, {
              class: "pv-input-size",
              dateFormat: "yy-mm-dd",
              disabled: true,
              modelValue: $setup.fechaInicioNovedad,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.fechaInicioNovedad) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.Salary.$error }]),
              minFractionDigits: 0,
              modelValue: $setup.empleado.Salary,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.empleado.Salary) = $event)),
              onInput: _cache[3] || (_cache[3] = ($event: any) => ($setup.v$.Salary.$touch()))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "currency-us",
              mode: "currency",
              currency: "COP",
              locale: "es-CO",
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.SalaryWorked.$error }]),
              minFractionDigits: 0,
              onInput: _cache[4] || (_cache[4] = ($event: any) => ($setup.v$.SalaryWorked.$touch())),
              modelValue: $setup.empleado.GeneralAccruals.SalaryWorked,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.empleado.GeneralAccruals.SalaryWorked) = $event))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_Dropdown, {
              showClear: "",
              options: $setup.Decision(),
              optionLabel: "nombre",
              optionValue: "nombre",
              placeholder: "Seleccione",
              class: "pv-input-size",
              modelValue: $setup.isIntegralSalary,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.isIntegralSalary) = $event)),
              onChange: $setup.SalarioIntegral
            }, null, 8, ["options", "modelValue", "onChange"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_Dropdown, {
              filter: "",
              showClear: "",
              optionLabel: "abreviatura",
              optionValue: "abreviatura",
              placeholder: "Seleccione",
              class: "pv-input-size",
              modelValue: $setup.workerTypeCode,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.workerTypeCode) = $event)),
              options: $setup.TiposTrabajador(),
              onChange: $setup.CodigoTipoTrabajador
            }, null, 8, ["modelValue", "options", "onChange"])
          ])
        ]),
        _createElementVNode("tr", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.Salary.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.Salary.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.SalaryWorked.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.SalaryWorked.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _hoisted_8,
          _hoisted_9
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createVNode(_component_Dropdown, {
              showClear: "",
              modelValue: $setup.subWorkerTypeCode,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.subWorkerTypeCode) = $event)),
              options: $setup.SubtiposTrabajador(),
              optionLabel: "abreviatura",
              optionValue: "abreviatura",
              placeholder: "Seleccione",
              class: "pv-input-size",
              onChange: $setup.CodigoSubTipoTrabajador
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_Dropdown, {
              showClear: "",
              modelValue: $setup.isHighRiskPension,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.isHighRiskPension) = $event)),
              options: $setup.Decision(),
              optionLabel: "nombre",
              optionValue: "nombre",
              placeholder: "Seleccione",
              class: "pv-input-size",
              onChange: $setup.AltoRiesgoPension
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_InputNumber, {
              min: 0,
              inputId: "minmax-buttons",
              mode: "decimal",
              class: _normalizeClass(["pv-input-size input-number", { 'p-invalid': $setup.v$.WorkedDays.$error }]),
              modelValue: $setup.empleado.GeneralAccruals.WorkedDays,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.empleado.GeneralAccruals.WorkedDays) = $event)),
              onInput: _cache[11] || (_cache[11] = ($event: any) => ($setup.v$.WorkedDays.$touch()))
            }, null, 8, ["modelValue", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_Calendar, {
              class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.AdmissionDate.$error }]),
              dateFormat: "yy-mm-dd",
              manualInput: $setup.empleado.AdmissionDate,
              showButtonBar: "",
              modelValue: $setup.empleado.AdmissionDate,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.empleado.AdmissionDate) = $event)),
              onBlur: $setup.ValidarFechaIngreso
            }, null, 8, ["manualInput", "modelValue", "onBlur", "class"])
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_Calendar, {
              modelValue: $setup.empleado.RetirementDate,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.empleado.RetirementDate) = $event)),
              class: "pv-input-size",
              dateFormat: "yy-mm-dd",
              showButtonBar: "",
              onBlur: $setup.FormatearFechas
            }, null, 8, ["modelValue", "onBlur"])
          ])
        ]),
        _createElementVNode("tr", _hoisted_12, [
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.WorkedDays.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.WorkedDays.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.AdmissionDate.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_Tooltip, {
                  key: error.$uid,
                  visible: $setup.v$.AdmissionDate.$error,
                  message: error.$message
                }, null, 8, ["visible", "message"]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}